/**
 * Normalized rating categories.
 * - Atradius: buyer rating (currentBuyerRating/currentBuyerRatingClass)
 * - Allianz: company grade (companyGrades.gradeCode)
 * - Coface: DRA or rating note (draHistory.ratingScore or ratingNote)
 */
export var RatingType;
(function (RatingType) {
    RatingType["BuyerRating"] = "buyer_rating";
    RatingType["Grade"] = "grade";
    RatingType["Dra"] = "dra";
    RatingType["RatingNote"] = "rating_note";
})(RatingType || (RatingType = {}));
